module.exports = __webpack_public_path__ + "img/user-av-gray.ede1f6f6.png";